<template>
	<div>
		<Subpage/>
	    <div class="page-content container">
	        <main>         
				<h1 class="page-title">Co możemy dla Ciebie zrobić?</h1>         
					<div class="breadcrumbs-area">
						<nav aria-label="breadcrumb"><ol class="breadcrumbs" itemscope itemtype="http://schema.org/BreadcrumbList"><li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
							<router-link itemprop="item" to="/"><span itemprop="name">Strona gł&oacute;wna</span></router-link>
							<span class="separator">/</span></li><li class="active">Co możemy dla Ciebie zrobić?</li></ol>
						</nav>
					</div>
	   					<p>Najlepsze rozwiązania rodzą się w drodze dyskusji! Dzięki kontaktowi z klientem oraz wsp&oacute;lnej analizie potrzeb dostosujemy nasze produkty do specyficznych wymagań obecnych i przyszłych Partner&oacute;w Biznesowych.</p>
						<h2>Co proponujemy?&nbsp;</h2>
						<p>W naszej ofercie znajdziecie Państwo wdrożone i przetestowane rozwiązania systemowe. Należą do nich:</p>
	    			<div class="faq">
	    				<FaqEntry v-for="item in faq" :key="faq.id" v-bind:title="item.title" v-bind:text="item.text" v-bind:id="item.id"></FaqEntry>	               
	    			</div>
	        </main>
	    </div>
  	</div>
</template>
<script>
import Subpage from '@/components/Subpage.vue'
import FaqEntry from '@/components/FaqEntry.vue'
export default {
  name: 'About',
  data: function () {
    return {
      	faq:[
      		{
		  		id:0,
		  		title:'System Pomiaru Temperatury',
		  		text:'System SPT oparty jest o wysokiej jakości kamery termowizyjne Q2901-E firmy AXIS. Pomiar temperatury odbywa się w jednej strefie obrazu (w danej chwili może być mierzona temperatura jednej osobie). Odległość kamery od osoby, której jest mierzona temperatura, powinna mieścić się w przedziale od 1,5 do 3 m. Zastosowane tego narzędzia pozwalają na:',		  		
		  	},
		  	{
		  		id:1,
		  		title:'System Druku Centralnego',
		  		text:'Szukasz narzędzia do obsługi korespondencji masowej? System Druku Centralnego jest właśnie dla Ciebie! Z jego pomocą możesz pobrać wskazaną korespondencję wraz z wymaganymi metadanymi, w odpowiedni sposób sformatować samą korespondencję, jak i kopertę oraz Zwrotne i Elektroniczne Potwierdzenie Odbioru (ZPO i EPO). To narzędzie umożliwia też sterowanie urządzeniami do sortowania dokumentów i wkładania ich do kopert (tzw. Kopertownice).'
		  	},
		  	{
		  		id:2,
		  		title:'System Wspomagania Organizacji Rozpraw',
		  		text:'Narzędzie dedykowane dla sądów powszechnych każdego szczebla: apelacyjnych, okręgowych i rejonowych. Umożliwia prezentację elektronicznej wokandy zarówno na dedykowanych urządzeniach przy salach rozpraw (wokandach elektronicznych), jak i w postaci strony internetowej (e-wokanda). Nasz SWOR współpracuje ze wszystkimi dostępnymi na polskim rynku systemami repertoryjnymi.'
		  	},
		  	{
		  		id:3,
		  		title:'e-BOI',
		  		text:'Kolejny z naszych systemów dedykowany dla sądownictwa powszechnego. Umożliwia pobieranie i prezentację najważniejszych informacji, dostępnych w repertoriach sądowych. System współpracuje ze wszystkimi dostępnymi na polskim rynku systemami repertoryjnymi. Informacje mogą być prezentowane zarówno dla upoważnionych pracowników sądów, jak i dla petentów.'
		  	},
		  	{
		  		id:4,
		  		title:'System Obsługi Wpłatomatu',
		  		text:'Produkt przeznaczony do kiosków i wpłatomatów, wykorzystywany m.in. w sądownictwie. Umożliwia on dostęp m.in. do: strony internetowej instytucji, w którym jest zainstalowany, portalu informacyjnego, systemu e-BOI, stron dedykowanych do dokonywania opłat (np. opłat sądowych: https://oplaty.ms.gov.pl). System blokuje możliwość wykorzystania innych adresów internetowych niż te zdefiniowane w konfiguracji. Narzędzie to blokuje także możliwość wykorzystywania skrótów klawiszowych, mających na celu włączenie innych systemów, np. Alt-Tab, Ctrl-Alt-Del, Ctrl-Esc.'
		  	},
		  	{
		  		id:5,
		  		title:'Usługa outsourcingo druku',
		  		text:'Usługa dedykowana dla tych, którym zamawianie materiałów eksploatacyjnych i usług serwisowych do urządzeń drukujących zajmuje zdecydowanie zbyt wiele czasu. Korzystając z outsourcingu druku Klient ponosi jedynie koszt wydruku takiej ilości stron, jaka faktycznie powstała na poszczególnych urządzeniach. Podawany na etapie przygotowania oferty koszt wydruku jednej strony zawiera cenę zarówno materiałów eksploatacyjnych jak i usług serwisowych. Dzięki zastosowaniu zaawansowanych narządzi software’owych materiały docierają zanim użytkownik zauważy ich brak, a serwis jest realizowany w taki sposób, aby użytkownikowi nie utrudniać pracy.'
		  	}
		]
    }
  },
  components: {
    Subpage,FaqEntry
  }
}
</script>